import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDTitleText } from '@facet-wealth/design';

export const metaOverrideSet = buildBaseOverrides()
  .nameOverride('name', {
    _component: () => Text,
    _customProps: { Component: FDTitleText, size: 'md', align: 'center' },
  }, overrideReadOnly);
